/* eslint-disable @typescript-eslint/no-explicit-any */
import { SharedAppConstants } from '@tock/shared-app-constants';

/*
 * Actions that originate from the headers such as the date dropdown picker.
 */

export function selectBusinessFilter(businessFilter: any): BaseTockAction {
  return {
    type: SharedAppConstants.OPTION_SELECTORS_SET_BUSINESS_FILTER,
    payload: businessFilter,
  };
}

export function setData(payload: any): BaseTockAction {
  return {
    type: SharedAppConstants.OPTION_SELECTORS_SET_DATA,
    payload,
  };
}
